export default "__VITE_ASSET__B_eX0KN4__"